import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask'
})
export class PhoneMaskPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // +90 ile başlıyorsa Türkiye formatına göre maskeler
    if (value.startsWith('+90') || value.startsWith('90')) {
      const cleaned = value.replace(/\D+/g, '').slice(2); // +90'ı kaldır ve sadece rakamları al
      if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)} ${cleaned.slice(6, 8)} ${cleaned.slice(8, 10)}`;
      }
      return cleaned; // Eğer uzunluk 10 değilse, temizlenmiş hali döner
    }

    // +90 ile başlamıyorsa gelen değeri aynen döner
    return value;
  }
}
